import React, { useContext } from "react";
import { useEffect, useState, useRef } from "react";
import "./style.css";
import { BouncingLoader } from "../../pure-components/Loader";
import API from "../../services/api";
import { toast } from "react-toastify";
import { ErrorToast, WarningToast } from "../../pure-components/CustomToast";
import { useHistory, useLocation, useParams } from "react-router-dom/cjs/react-router-dom.min";
import ActionRecords from "../ActionRecords";
import FloatingButton from "./floatingButton";
import CookieManager from "../../services/CookieManager";
import TrackContext from "../../contexts/track-context";
import { ReactComponent as CloseModal } from "../../assets/modal-close.svg";
import { Link } from "react-router-dom/cjs/react-router-dom";
import Helper from "../../services/helper";
import defaultImage from "../../assets/default_music.png";
import Track from "../Track";
import AddTrackToProjectPopup from "../Projects/addTrackToProjectPopup";
import textFileLogo from "../../assets/logo/text-file-icon.png";
import Constants from "../../services/constants";
import HarvestService from "../../services/harvestService";
import MediaTile from "../Catalog/media-tile";

const Music = (props) => {
  const location = useLocation();
  const loadMoreRef = useRef(null);
  const history=useHistory()
  const [searchText,setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [trackList, setTrackList] = useState([]);
  const [trackIds, setTrackIds] = useState([]);
  const [albumList, setAlbumList] = useState([]);
  const [catalogList, setCatalogList] = useState([]);
  const trackContext = useContext(TrackContext);
  const {
    searchkey,
    setSearchkey,
  } = trackContext;
  const [albumView, setAlbumView] = useState(false);
  const [trackView, setTrackView] = useState(false);

  const [showProjectModal, setShowProjectModal] = useState(false);
  const [trackToBeAddedToProject, setTrackToBeAddedToProject] = useState("");  
  const [expandedTrackId, setExpandedTrackId] = useState("");
  const [downloadingTracks, setDownloadingTracks] = useState([]);
  const [favingTracks, setFavingTracks] = useState([]);
  const pageId = "music";

  const [allDataLoaded, setAllDataLoaded] = useState(true);
  const [pageNo, setPageNo] = useState(0);
  const [showLoader, setShowLoader] = useState(false)

  
  useEffect(() => {
    if(window.location.pathname.includes("/music/tracks")){
      if(!searchkey){
        history.push("/");
        return;
      }

      setTrackView(true);
      setAlbumView(false);
      setTrackList([]);
      setPageNo(0);
      (async() => {
          await loadMusicData(getFilterObj("track", searchkey, 0), false, true);
      })()

    }else if(window.location.pathname.includes("/music/albums")){
      if(!searchkey){
        history.push("/");
        return;
      }

      setAlbumView(true);
      setTrackView(false);
      setAlbumList([]);
      setPageNo(0);
      (async() => {
          await loadMusicData(getFilterObj("album", searchkey, 0), true, true);
      })()

    }else if(window.location.pathname === "/"){
      setTrackList([]);
      (async() => {
          await loadTrackData();
      })()
    }
  }, [window.location.pathname])

  useEffect(() => {
    // console.log("list data : ", trackList, albumList)
  },[trackList, albumList])

  const getFilterObj = (type, searchPhrase, pageNo) => {
    switch(type) {
      case "track" : 
        return {
          "SearchFilters": {
            "SearchType": "Normal",
            "IncludeInactive": "false",
            "MainOnly": "true",
            "SearchTermBundle": {
                "St_Keyword_Aggregated": {
                    "ExactPhrase": "false",
                    "Wildcard": "false",
                    "DisableKeywordGroup": "false",
                    "OrOperation": "false",
                    "Keywords": searchPhrase,
                    "Negative": "false"
                }
            },
            "ResultView": {
                "View" : "Track",
                "Sort_Predefined": "RankExpression",
                "RankExpression": "-deim,-rdt,-cdc-num",
                
                // "Sort_Predefined": "EvokeRanking",
                "Evoke_PrioritizeBPM": false,
                "Evoke_SuppressVocals": false,
                "Skip": pageNo * Constants.ALBUM_TRACKS_DEFAULT_PAGE_SIZE,
                "Limit": Constants.ALBUM_TRACKS_DEFAULT_PAGE_SIZE,
                include_lyrics : true
            }
          }
        }
      case "album" : 
        return {
          "SearchFilters": {
            "SearchType": "Normal",
            "IncludeInactive": "false",
            "MainOnly": "true",
            "SearchTermBundle": {
                "St_Keyword_Aggregated": {
                    "ExactPhrase": "false",
                    "Wildcard": "false",
                    "DisableKeywordGroup": "false",
                    "OrOperation": "false",
                    "Keywords": searchPhrase,
                    "Negative": "false"
                }
            },
            "ResultView": {
                "View" : "Album",
                "Sort_Predefined": "RankExpression",
                "RankExpression": "-max(deim_album)",
                
                // "Sort_Predefined": "EvokeRanking",
                "Evoke_PrioritizeBPM": false,
                "Evoke_SuppressVocals": false,
                "Skip": pageNo * Constants.ALBUM_TRACKS_DEFAULT_PAGE_SIZE,
                "Limit": Constants.ALBUM_TRACKS_DEFAULT_PAGE_SIZE
            }
          }
        }
      default : 
        return {
          "SearchFilters": {
            "SearchType": "Normal",
            "IncludeInactive": "false",
            "MainOnly": "true",
            "SearchTermBundle": {
                "St_Keyword_Aggregated": {
                    "ExactPhrase": "false",
                    "Wildcard": "false",
                    "DisableKeywordGroup": "false",
                    "OrOperation": "false",
                    "Keywords": searchPhrase,
                    "Negative": "false"
                }
            },
            "ResultView": {
                "View" : "Track",
                "Sort_Predefined": "RankExpression",
                "RankExpression": "-deim,-rdt,-cdc-num",
                
                // "Sort_Predefined": "EvokeRanking",
                "Evoke_PrioritizeBPM": false,
                "Evoke_SuppressVocals": false,
                "Skip": pageNo * Constants.ALBUM_TRACKS_DEFAULT_PAGE_SIZE,
                "Limit": Constants.ALBUM_TRACKS_DEFAULT_PAGE_SIZE,
                include_lyrics : true
            }
          }
        }
    }
  }
  const loadTrackData = async(searchText = "") => {
    setLoading(true);
    const filter = {
      "Keyword":searchText || Helper.getRandomMusicKey(),
      "Wildcard":false,
      "ReturnTracks":true,
      "ReturnTracks_MainOnly":true,
      "ReturnTracks_Fields":"ID, AlbumID, AlbumName, DisplayTitle, Name, LengthSeconds, Bpm, AlternateCount, Publisher, Artist, Keywords,AlternateTitle",
      "ReturnTracks_Limit":100,
      "ReturnTracks_Order":"",
      "ReturnTracks_DisableKeywordGroup":false,
      "ReturnTracks_Rank":"",
      "ReturnAlbums":true,
      "ReturnAlbums_Fields":"CdCode,DisplayTitle,Description,Keywords",
      "ReturnAlbums_Limit":1000,
      "ReturnAlbums_Order":"",
      "ReturnAlbums_DisableKeywordGroup":false,
      "ReturnLibraries":true,
      "ReturnLibraries_Fields":"Name,Prefix,Description",
      "ReturnLibraries_Limit":1000,
      "ReturnLibraries_DisableKeywordGroup":false,
      "ReturnStyles":false,
      "ReturnStyles_Limit":1,
      "ReturnStyles_Order":"",
      "ReturnStyles_DisableKeywordGroup":false,
      "ReturnCategoryAttributes":false,
      "ReturnCategoryAttributes_Limit":1,
      "ReturnCategoryAttributes_ShowOnPlayerOnly":false,
      "ReturnCategoryAttributes_IncludeCategory":false,
      "ReturnCategoryAttributes_Order":"AllAlphabetic",
      "ReturnCategoryAttributes_DisableKeywordGroup":false,
      "ReturnRightHolders":false,
      "ReturnRightHolders_Fields":"firstname, lastname",
      "ReturnRightHolders_Limit":1,
      "ReturnRightHolders_DisableKeywordGroup":false,
      "RightHolderTypes":"Artist",
      "ReturnLyrics":false,
      "ReturnLyrics_Limit":1,
      "ReturnLyrics_MainOnly":false,
      "ReturnLyrics_DisableKeywordGroup":false,
      "ReturnKeywords":false,
      "ReturnKeywordsMaxSize":1,
      "ReturnKeywordsForMatch":false,
      "ReturnKeywordsForMatch_Fields":"",
      "ReturnKeywordsForMatch_HideWhenSearchTerm":false,
      "ReturnKeywordsDisableKeywordGroup":false,
      "ReturnFeaturedPlaylists":false,
      "ReturnFeaturedPlaylist_Fields":"ProjectTitle,Description",
      "ReturnFeaturedPlaylists_Limit": 1,
      "ReturnFeaturedPlaylist_Order":"Alphabetic_Ascent",
      "ReturnFeaturedPlaylists_DisableKeywordGroup":false

    }
    const reqObj = {
      refUrl : `/autocomplete/{memberToken}`, 
      method : 'post',
      headers : {
          "Accept" : "application/json",
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': '0',
      },
      data : JSON.stringify(filter)
    };
    await HarvestService.loadHarvestData(reqObj).then((resp) => {
      // console.log("Music data : ", resp);
      if(resp){
        setTrackList(resp.Tracks);
        const ids = resp.Tracks?.map(e => e.TrackID);
        setTrackIds(ids);

        setAlbumList(resp.Albums || []);
        setCatalogList(resp.Libraries || []);

      }
      else{
        console.log("Music data loading error : ", resp);
      }
      
    }).catch((err) => {
      console.log("Music data loading error : ", err);
      toast(({ closeToast }) => <ErrorToast message={"Music data loading error."} />);
    }).finally(() => {
      setLoading(false);
      setAllDataLoaded(true);
    })
  }

  const loadMusicData = async(filter, album = false, initialLoading = false) => {
    if(loading) return;
    setLoading(true);
    const reqObj = {
      refUrl : `/cloudsearch/{memberToken}`, 
      method : 'post',
      headers : {
          "Accept" : "application/json",
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': '0',
      },
      data : JSON.stringify(filter)
    };
    await HarvestService.loadHarvestData(reqObj).then((resp) => {
      // console.log("response data : ", resp)
      
      if(album){
        const tempData = initialLoading ? [] : [...albumList];
        if(resp?.Albums?.length > 0)
          tempData.push(...resp.Albums);
        if(tempData?.length < resp?.TotalAlbums)
          setAllDataLoaded(false);
        else
          setAllDataLoaded(true); 
        setAlbumList(tempData);     
        // setPageNo(pageNo + 1);  
        if(!allDataLoaded && (!resp?.Albums || resp?.Albums?.length === 0)){
          toast(({ closeToast }) => <WarningToast  message={"No album found for searched query."}/>);
          return;
        }
      }else{
        const tempData = initialLoading ? [] : [...trackList];
        if(resp?.Tracks?.length > 0)
          tempData.push(...resp.Tracks);
        if(tempData?.length < resp?.TotalTracks)
          setAllDataLoaded(false);
        else
          setAllDataLoaded(true);
        setTrackList(tempData);  
        // setPageNo(pageNo + 1);
        if(!allDataLoaded && (!resp?.Tracks || resp?.Tracks?.length === 0)){
          toast(({ closeToast }) => <WarningToast  message={"No tracks found for searched query."}/>);
          return;
        }
      }
      
    }).catch((err) => {
      console.log("Track List Loading Error : ", err);
      //Modify the error handling when array returned as error
      toast(({ closeToast }) => <ErrorToast  message={"Searched track list loading error."}/>);
    }).finally(()=> {
      setLoading(false);
      setShowLoader(false);
    });
    
  }

  const handleSearch = async(e) => {
    if(e?.key === 'Enter' && !loading){
      await loadMusicData(searchText);
    }
  };

  const handleSearchBoxClick = async (e) => {
    let userData = JSON.parse(CookieManager.getCookie('user-data'));
    //  if (trackContext.userDetails.email === undefined || trackContext.userDetails.subscribed === false) 
    if (userData === null) {
      trackContext.setShowSubscribePopup(true);
      trackContext.setUserAction('AI Search');
      return;
    }
      trackContext.setSearch(true);
  }
  
  const removeSearchText = () => {
    setSearchkey("");
    trackContext.setSearchResultView("");
    history.push("/");
  }

  const displayProjectModal = (trackId) => {
    setTrackToBeAddedToProject(trackId);
    setShowProjectModal(true);
  };

  const closeProjectModal = () => {
    setShowProjectModal(false);
  };

  useEffect(() => {
    if (!showLoader || allDataLoaded || loading) {
      return;
    }

    const nextPage = pageNo + 1;
    const dataType = albumView ? "album" : "track";

    setPageNo(nextPage);
    (async () => {
      await loadMusicData(getFilterObj(dataType, searchkey, nextPage), albumView, false);
    })();
  }, [showLoader, allDataLoaded, loading, albumView, searchkey, pageNo]);

  useEffect(() => {
    const sentinel = loadMoreRef.current;
    if (!sentinel || allDataLoaded || loading) {
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (entry?.isIntersecting) {
        setShowLoader(true);
      }
    }, {
      root: null,
      rootMargin: "200px",
      threshold: 0.1,
    });

    observer.observe(sentinel);
    return () => observer.disconnect();
  }, [allDataLoaded, loading, albumView, searchkey, pageNo, trackList.length, albumList.length]);


  const loadMoreData = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        if (allDataLoaded) {
          setShowLoader(false);
        } else {
          setShowLoader(true);
        }
      }
    });
  };

  const getComposers = (compNames) => {
    const tempData = {};
    if(compNames?.length > 0){
      const arr = compNames.split(",");
      arr?.length > 1 && arr.forEach((elem, idx) => {
        tempData[idx] = elem;
      });
      arr?.length === 1 && (() => {tempData["1"] = arr[0]})();
    }
    return tempData;
  }
  return (
    <>
    <div className="sm:flex sm:flex-col sm:w-full lg:mx-auto" style={{minHeight: "80vh", maxHeight : "80vh", overflowY:"scroll"}}>
      {/* <div className="w-full rounded-full aisearch border-pink flex">
        <input
          // onChange={event => { setSearchText(event.target.value) }}
          // onKeyDown={handleSearch}
          // onBlur={() => {!loading && loadMusicData(searchText)}}
          onFocus={e => handleSearchBoxClick(e)}
          className="self-center w-full md:truncate bg-white outline-none cursor-pointer placeholder-textGray-600 rounded-full pl-2 py-1"
          placeholder="Search by title or artist"
          disabled={loading}
          value={searchText}
        />
      </div>
      
      <div className="border-t my-2"></div> */}
      
      <div className="w-full">
        
        {albumView && <>
          {!loading && searchkey?.length > 0 &&
          <>
            <div className="w-full flex text-sm text-start my-3">
              <b className="text-base ml-2 mt-1">Search Result for : &nbsp;</b>
              <div className="rounded-full w-11/12 lg:w-auto filter-tile-pink text-title px-2 mx-1 pb-1 row-line">
                <img
                  src={textFileLogo}
                  alt="logo"
                  className="h-3.5 mt-1 mr-1"
                  title="text search"
                />
                {/* {musicFilter.searchText} */}
                <div className=" w-11/12 lg:w-auto truncate">{searchkey}</div>
                <CloseModal className="closefilter mt-1.5 ml-3 cursor-pointer" onClick={() => removeSearchText()} />
              </div>
            </div>
          </>}
          {(loading || !(albumList?.length > 0)) && (
            <div className="w-full">
              <BouncingLoader />
            </div>
          )}
          {!loading && !(albumList?.length > 0) ? (
            <div className="text-xl text-center text-red-500 my-5">
              No Album Found
            </div>
          ) : (
          <>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 xl:grid-cols-6 gap-3 sm:gap-2 md:gap-2 mt-4">
              {albumList?.map((elem, index) => (
                <Link to={`/album/${elem?.ID}`} key={elem?.ID}>
                  {/* <div className="music-tile">
                    <div className="image-container relative">
                      {Helper.getArtworkURL(elem?.ID)?.length > 0? (
                        <img
                          src={Helper.getArtworkURL(elem?.ID) || defaultImage}
                          alt="Album img"
                          onError={(e) => {     e.target.onerror = null;     e.target.src = defaultImage   }}
                          className="w-full border cursor-pointer object-cover aspect-square"
                          loading="lazy"
                        />
                      ) : (
                        <img
                          src={defaultImage}
                          alt="Album img"
                          className="w-full border-b cursor-pointer music-image justify-center align-middle object-cover aspect-square"
                          loading="lazy"
                        />
                      )}
                      <span className="play_icon absolute" title="Play"></span>
                    </div>
                    <div className="p-2">
                      <p className="text-sm font-bold line-clamp-1">{elem?.Name || elem?.DisplayTitle}</p>
                      {elem.Detail?.length > 0 &&
                        <p className="text-xs sm:text-sm font-light text-left description line-clamp-2"
                          title={elem?.Detail}
                        >
                          {elem?.Detail || elem?.DisplayTitle || elem?.Name}
                        </p>
                      }
                    </div>
                  </div> */}
                  <MediaTile
                    style={{ backgroundColor: "rgb(var(--bg))", color: "rgb(var(--text))" }}
                    onmouseover="this.style.color='red'" 
                    onmouseout="this.style.color='blue'"
                    image={Helper.getArtworkURL(elem?.ID) || defaultImage}
                    title={elem?.Name || elem?.DisplayTitle}
                    code=""
                    description={elem?.Detail || elem?.DisplayTitle || elem?.Name}
                    id={elem.ID}
                  />
                </Link>
              ))}
            </div>
            {!allDataLoaded && albumList?.length > 0 && (
              <div id="load-more-data" ref={loadMoreRef} className="w-full p-2">
                {showLoader && <BouncingLoader />}
              </div>
            )}
          </>
          )}
        </>}
        {trackView && <>
          {!loading && searchkey?.length > 0 &&
          <>
            <div className="w-full flex text-sm text-start my-3">
              <b className="text-base ml-2 mt-1">Search Result for : &nbsp;</b>
              <div className="rounded-full w-11/12 lg:w-auto filter-tile-pink text-title px-2 mx-1 pb-1 row-line">
                <img
                  src={textFileLogo}
                  alt="logo"
                  className="h-3.5 mt-1 mr-1"
                  title="text search"
                />
                {/* {musicFilter.searchText} */}
                <div className=" w-11/12 lg:w-auto truncate">{searchkey}</div>
                <CloseModal className="closefilter mt-1.5 ml-3 cursor-pointer" onClick={() => removeSearchText()} />
              </div>
            </div>
          </>}
          {(loading || !(trackList?.length > 0)) && (
            <div className="w-full">
              <BouncingLoader />
            </div>
          )}
          {!loading && !(trackList?.length > 0) ? (
            <div className="text-xl text-center text-red-500 my-5">
              No Track Found
            </div>
          ) : (<>
            <div className="text-xl w-full mt-2">
              {trackList?.map((track, index, arr) => {
              return (
                
                  <Track
                    image={Helper.getArtworkURL(track.AlbumID)}
                    key={track.ID}
                    albumId={track.AlbumID}
                    title={track.DisplayTitle || track.Name}
                    duration={track.LengthSeconds}
                    bpm={track.Bpm}
                    versions={track.AlternateCount}
                    producer={track.Publisher}
                    artistName={
                      track.Composer
                    }
                    album={track.AlbumName}
                    trackId={track.ID}
                    waveform={Helper.getWaveformURL(track.ID)}
                    // setTrackUrl={props.setTrackUrl}
                    // setFetchingTrack={trackContext.setFetchingTrack}
                    // changeCurrentTrackImage={props.changeCurrentTrackImage}
                    displayProjectModal={displayProjectModal}
                    // handleCurrentTrackDetail={props.handleCurrentTrackDetail}
                    // similarity={track?.similarity}
                    description={track?.Comment}
                    expandedTrackId={expandedTrackId}
                    setExpandedTrackId={setExpandedTrackId}
                    pageId={pageId}
                    artists={
                      Helper.getComposers(track.Composers)
                    }

                    downloadingTracks = {downloadingTracks}
                    setDownloadingTracks = {setDownloadingTracks}
                    favingTracks = {favingTracks}
                    setFavingTracks = {setFavingTracks}
                    lyrics = {track.Lyrics || ""}
                  />
                
                )
              })}
            </div>
            {!allDataLoaded && (
              <div id="load-more-data" ref={loadMoreRef} className="w-full p-2">
                {showLoader && <BouncingLoader />}
              </div>
            )}
          </>)}
        </>}
        {!albumView && !trackView &&
        <>
          {loading && (
            <div className="w-full">
              <BouncingLoader />
            </div>
          )}
          {!loading && !(trackList?.length > 0) ? (
            <div className="text-xl text-center text-red-500 my-5">
              No Track Found
            </div>
          ) : (
            <div className="w-full  sm:flex sm:flex-wrap  justify-center">
              {!loading && trackIds?.length > 0 && <ActionRecords trackIds={trackIds}/>}
            </div>
          )}
        </>}
      </div>
    </div>
    {showProjectModal && (
      <AddTrackToProjectPopup
        trackToBeAddedToProject={trackToBeAddedToProject}
        closeProjectModal={closeProjectModal}
      />
    )}
    {/* {!loading &&
    <div>
      <FloatingButton searchText = {searchText} albumList = {albumList} catalogList = {catalogList} />
    </div>} */}
    </>
  );
};

export default Music;